
import { UserRole } from "@/hooks/useUserRoles";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { useState } from "react";

interface UserWithRoles {
  id: string;
  email: string;
  roles: UserRole[];
}

interface AddRoleDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedUser: UserWithRoles | null;
  onAddRole: () => Promise<void>;
  newRole: UserRole;
  onRoleChange: (role: UserRole) => void;
}

const AddRoleDialog = ({
  isOpen,
  onOpenChange,
  selectedUser,
  onAddRole,
  newRole,
  onRoleChange,
}: AddRoleDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Adicionar Função</DialogTitle>
          <DialogDescription>
            Adicionar uma função para {selectedUser?.email}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Select
            value={newRole}
            onValueChange={(value: UserRole) => onRoleChange(value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione uma função" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="admin">Administrador</SelectItem>
              <SelectItem value="marketing">Marketing</SelectItem>
              <SelectItem value="support">Suporte</SelectItem>
              <SelectItem value="integrations_manager">Gerente de Integrações</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={onAddRole}>Adicionar Função</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddRoleDialog;
